import React, { useEffect, useState } from "react";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirstLetter } from "../../utils/comman";
import { userDataElementListById } from "../../actions/user";

const UserDataElements = () => {
  const dispatch = useDispatch<any>();
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const [loading, setLoading] = useState<boolean>(true);
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );
  const [data, setData] = useState<any[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDataElementList = (params = {}) => {
    setLoading(true);
    const payload = {
      ...params,
    };
    dispatch(
      userDataElementListById(payload, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setData(resp.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    // if (handleRefresh)
    fetchDataElementList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
    });
  }, [handleRefresh]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    fetchDataElementList({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const columns = [
    {
      title: "Org",
      dataIndex: "organizationName",
      key: "organizationName",
      render: (_: any, record: any) =>
        record?.orgElementsLinks
          ?.map((link: any) => link.organization?.shortCode)
          .join(", "),
      sorter: true,
    },
    {
      title: "Category",
      dataIndex: "categoryName", // Custom dataIndex, not present in the dataset
      key: "category",
      render: (_, record) => record?.category?.name || "-", // Extracts the category name from record
      sorter: true,
    },
    {
      title: "Element Name",
      dataIndex: "DataElements_Name",
      key: "DataElements_Name",
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "DataElements_Description",
      key: "DataElements_Description",
    },
    {
      title: "Is Budgeted",
      dataIndex: "DataElements_IsBudgeted",
      key: "DataElements_IsBudgeted",
      render: (value: boolean) => (value ? "Yes" : "No"),
    },
    {
      title: "Element Type",
      dataIndex: "DataElements_DataType",
      key: "DataElements_DataType",
      render: (text: string) => capitalizeFirstLetter(text),
    },
  ];

  return (
    <div>
      {/* <Header /> */}

      <div className="flex justify-between">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Data Elements
        </h1>
      </div>

      <div className="table-col">
        <DataTable
          columns={columns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default UserDataElements;
